<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Configurações'" :novo="novo" :titulo="'Configurações:'" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-12"> 
          <h4>Logotipos</h4>
        </div>
        <div class="col-sm-6"><label>Logotipo cabeçalho:</label></div>
        <div class="col-sm-6"><label>Logotipo rodapé:</label></div>
          <div class="col-sm-6 text-center">
          
           <div
              class="areaFoto"
              :class="contentEdit.logotipoCabecalho? 'ativo':''"
              @click="$refs.logotipoCabecalho.click()"
              :style="contentEdit.logotipoCabecalho && carregado? 'background:url(' + contentEdit.logotipoCabecalho+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="logotipoCabecalho"
                name="logotipoCabecalho"
                ref="logotipoCabecalho"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="contentEdit.logotipoCabecalho"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('logotipoCabecalho',1)"
            >Remover foto</button>
          </div>
          <div class="col-sm-6 text-center">
          
           <div
              class="areaFoto"
              :class="contentEdit.logotipoRodape? 'ativo':''"
              @click="$refs.logotipoRodape.click()"
              :style="contentEdit.logotipoRodape && carregado? 'background:url(' + contentEdit.logotipoRodape+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="logotipoRodape"
                name="logotipoRodape"
                ref="logotipoRodape"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="contentEdit.logotipoRodape"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('logotipoRodape',2)"
            >Remover foto</button>
          </div>

        <div class="clearfix"></div>
        <div class="col-12"> 
          <h4>Configurações cabeçalho</h4>
        </div>
        <div class="col-3 form-group">
          <label>Menu Home:</label>
          <input
            type="text"
            v-model="contentEdit.menu1"
            name="menu1"
            id="menu1"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-3 form-group">
          <label>Menu Quem Somos:</label>
          <input
            type="text"
            v-model="contentEdit.menu2"
            name="menu2"
            id="menu2"
            class="form-control required valid"
            value
          />
        </div>

        <div class="col-3 form-group">
          <label>Menu Segmentos:</label>
          <input
            type="text"
            v-model="contentEdit.menu3"
            name="menu3"
            id="menu3"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-3 form-group">
          <label>Menu Clientes:</label>
          <input
            type="text"
            v-model="contentEdit.menu4"
            name="menu4"
            id="menu4"
            class="form-control required valid"
            value
          />
        </div>
         <div class="col-12"> 
          <hr>
          <h4>Configurações rodapé</h4>
        </div>
       
        <div class="col-12 form-group">
          <label>Frase sobre:</label>
          <textarea
            v-model="contentEdit.rodapeSobre"
            name="rodapeSobre"
            id="rodapeSobre"
            class="form-control required valid"
            value
          ></textarea>
        </div>
        <div class="col-12 form-group">
          <label>Frase direitos:</label>
          <input
            type="text"
            v-model="contentEdit.fraseDireitos"
            name="fraseDireitos"
            id="fraseDireitos"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12"> 
          <hr>
          <h4>Seção Contato</h4>
        </div>
         <div class="col-4 form-group">
          <label>Telefone:</label>
          <input
            type="text"
            v-model="contentEdit.telefone"
            name="telefone"
            id="telefone"
            class="form-control required valid"
            value
          />
        </div>
         <div class="col-4 form-group">
          <label>E-mail:</label>
          <input
            type="text"
            v-model="contentEdit.email"
            name="email"
            id="email"
            class="form-control required valid"
            value
          />
        </div>
         <div class="col-4 form-group">
          <label>Horário:</label>
          <input
            type="text"
            v-model="contentEdit.horario"
            name="horario"
            id="horario"
            class="form-control required valid"
            value
          />
        </div>
       <div class="col-12"> 
          <hr>
          <h4>Seção Sobre</h4>
        </div>
        <div class="col-12 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.tituloSobre"
            name="tituloSobre"
            id="tituloSobre"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Intro:</label>
          <textarea
            v-model="contentEdit.introSobre"
            name="introSobre"
            id="introSobre"
            class="form-control required valid"
            value
          ></textarea>
        </div>
        <div class="col-12 form-group">
          <label>Texto sobre:</label>
          <textarea
            v-model="contentEdit.textoSobre"
            name="textoSobre"
            id="textoSobre"
            class="form-control required valid"
            value
          ></textarea>
        </div>
        <div class="col-12 form-group">
          <label>Texto Valores:</label>
          <textarea
            v-model="contentEdit.textoValores"
            name="textoValores"
            id="textoValores"
            class="form-control required valid"
            value
          ></textarea>
        </div>
        <div class="col-12 form-group">
          <label>Texto qualidade:</label>
          <textarea
            v-model="contentEdit.textoQualidade"
            name="textoQualidade"
            id="textoQualidade"
            class="form-control required valid"
            value
          ></textarea>
        </div>
          <div class="col-sm-6 text-center">
          <label>Imagem:</label>
           <div
              class="areaFoto"
              :class="contentEdit.imagemSobre? 'ativo':''"
              @click="$refs.imagemSobre.click()"
              :style="contentEdit.imagemSobre && carregado? 'background:url(' + contentEdit.imagemSobre+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="imagemSobre"
                name="imagemSobre"
                ref="imagemSobre"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="contentEdit.imagemSobre"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('imagemSobre',2)"
            >Remover foto</button>
          </div>


        <div class="col-12"> 
          <hr>
          <h4>Seção Área de atuação</h4>
        </div>
        <div class="col-12 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.tituloAreaAtuacao"
            name="tituloAreaAtuacao"
            id="tituloAreaAtuacao"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Intro:</label>
          <textarea
            v-model="contentEdit.introAreaAtuacao"
            name="introAreaAtuacao"
            id="introAreaAtuacao"
            class="form-control required valid"
            value
          ></textarea>
        </div>
        <div class="col-12 form-group">
          <label>Áreas de atuações:</label>
          <textarea
            v-model="contentEdit.areasAtuacoes"
            name="areasAtuacoes"
            id="areasAtuacoes"
            class="form-control required valid"
            value
          ></textarea>
        </div>

        <div class="col-12"> 
          <hr>
          <h4>Seção Área de atuação</h4>
        </div>
        <div class="col-12 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.tituloServicos"
            name="tituloServicos"
            id="tituloServicos"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Intro:</label>
          <textarea
            v-model="contentEdit.introServicos"
            name="introServicos"
            id="introServicos"
            class="form-control required valid"
            value
          ></textarea>
        </div>
        <div class="col-12"> 
          <hr>
          <h4>Seção programa de afiliados</h4>
        </div>
        <div class="col-12 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.tituloEquipe"
            name="tituloEquipe"
            id="tituloEquipe"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Intro:</label>
          <textarea
            v-model="contentEdit.introEquipe"
            name="introEquipe"
            id="introEquipe"
            class="form-control required valid"
            value
          ></textarea>
        </div>


         
        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData,getSuccess,getError,urlApi } from "../../global/utils";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      error:null,
      contentFotos: [],
      carregado:true,
      files: [],
      logotipoCabecalho: [],
      logotipoRodape: [],
      imagemSobre: [],
      contentEdit: {
        titulo:'',
        ativo: false,
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]

    };
  },
  components: { Tbheader  },
  methods: {
OnFileSelected(event) {
      if (event.target.id == "logotipoCabecalho") {
        this.contentEdit.logotipoCabecalho = URL.createObjectURL(event.target.files[0]);
        this.logotipoCabecalho = event.target.files[0];
       this.carregado = true;
      } else if (event.target.id == "logotipoRodape") {
        this.contentEdit.logotipoRodape = URL.createObjectURL(event.target.files[0]);
        this.logotipoRodape = event.target.files[0];
        this.carregado = true;
      }  else if (event.target.id == "imagemSobre") {
        this.contentEdit.imagemSobre = URL.createObjectURL(event.target.files[0]);
        this.imagemSobre = event.target.files[0];
        this.carregado = true;
      } 
    },
    fnRemoveFoto(tipo, i) {
      var filename = '';
        if (i == 1) {
          filename = this.contentEdit.logotipoCabecalho.split('/').pop().split('#')[0].split('?')[0]
          this.contentEdit.logotipoCabecalho = null;
        } else if (i == 2) {
          filename = this.contentEdit.logotipoRodape.split('/').pop().split('#')[0].split('?')[0]
          this.contentEdit.logotipoRodape = null;
       } else if (i == 3) {
          filename = this.contentEdit.imagemSobre.split('/').pop().split('#')[0].split('?')[0]
          this.contentEdit.imagemSobre = null;
       } 
      this.$http
        .delete("eoficinas/upload/eoficinas/config/" +filename +"/arquivo")
        .then((res) => {
          console.log(res);
        });

    },
   GetFilename(url)
    {
      if (url)
      {
          var m = url.toString().match(/.*\/(.+?)\./);
          if (m && m.length > 1)
          {
            return m[1];
          }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if(this.logotipoCabecalho.name != undefined){
       fd.append("files", this.logotipoCabecalho, this.logotipoCabecalho.name);
      }
      if(this.logotipoRodape.name != undefined){
       fd.append("files", this.logotipoRodape, this.logotipoRodape.name);
      }
      if(this.imagemSobre.name != undefined){
       fd.append("files", this.imagemSobre, this.imagemSobre.name);
      }
      this.$http
        .post("eoficinas/upload/eoficinas/config", fd)
        .then(() => {
          this.carregado = true;


        });
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: `/eoficinas/configuracoes/`})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post'
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''
      const imgUrl =
      urlApi + "Upload/eoficinas/config/";
      var chamaUpload = false;
      if(this.logotipoCabecalho.name != undefined){
        chamaUpload = true;
        this.contentEdit.logotipoCabecalho  = imgUrl + this.logotipoCabecalho.name;
      }
      if(this.logotipoRodape.name != undefined){
       chamaUpload = true;
       this.contentEdit.logotipoRodape  = imgUrl + this.logotipoRodape.name;
      }
      if(this.imagemSobre.name != undefined){
       chamaUpload = true;
       this.contentEdit.imagemSobre  = imgUrl + this.imagemSobre.name;
      }

       let data = await this.$http[metodo]("/eoficinas/configuracoes" + completaUrl,this.contentEdit)
        .then(() =>{
          if(chamaUpload){
            this.OnUpload();
          }
            getSuccess();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"eoficinas/configuracoes/"+valueId);
      this.contentEdit = data[0].content;
      this.$vs.loading.close()
    }

  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#editor1,#editor2,#editor3{
	min-height: 50vh;
}
</style>